// extracted by mini-css-extract-plugin
export default {"title":"add-contact_title__iiNgQ","field":"add-contact_field__STSr-","line":"add-contact_line__yzZ3p","content":"add-contact_content__mRITi"};